import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
    { label: "Solutions", path: "/solutions" },
    { label: "Industries", path: "/industries" },
    { label: "Developers", path: "/developers" },
    { label: "Products & Services", path: "/products-services" },
];

function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    return (
        <header className="site-header">
            <div className="container nav-wrap">
                <Link className="brand" to="/">
                    <img src="/logo.svg" alt="Everest" style={{ height: 28, width: "auto" }} />
                </Link>
                <nav
                    className={`primary-nav${mobileOpen ? " open" : ""}`}
                    aria-label="Primary"
                >
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={location.pathname === link.path ? "active" : ""}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>
                <div className="nav-actions">
                    <a className="sign-in-link" href="https://account.everest.org" target="_blank" rel="noopener noreferrer">Sign in</a>
                    <Link className="btn btn-primary nav-cta" to="/contact">Contact Us</Link>
                </div>
                <button
                    className="mobile-toggle"
                    aria-label="Toggle navigation"
                    aria-expanded={mobileOpen}
                    onClick={() => setMobileOpen(!mobileOpen)}
                >
                    &#9776;
                </button>
            </div>
        </header>
    );
}

function Footer() {
    return (
        <footer className="site-footer">
            <div className="container footer-grid">
                <div>
                    <Link className="brand" to="/">
                        <img src="/logo.svg" alt="Everest" style={{ height: 28, width: "auto" }} />
                    </Link>
                    <p style={{ marginTop: 14 }}>
                        Tower Business Centre 2nd floor <br />
                        TRIQ IT- TORRI <br />
                        SWATAR BIRKIRKARA <br />
                        BKR 4013 <br />
                        Malta <br />
                        <a href="mailto:contact@everest.org">contact@everest.org</a><br />
                        <a href="tel:+35625466021">+(356) 2546-6021</a>
                        <br />
                        Company Number: C89123
                    </p>
                </div>
                <div className="footer-links">
                    <strong>Product &amp; Solutions</strong>
                    <Link to="/solutions">Solutions</Link>
                    <Link to="/industries">Industries</Link>
                    <Link to="/developers">Developers</Link>
                    <Link to="/products-services">Products &amp; Services</Link>
                </div>
                <div className="footer-links">
                    <strong>Company</strong>
                    <Link to="/careers">Careers</Link>
                    <Link to="/contact">Contact</Link>
                </div>
                <div className="footer-links">
                    <strong>Legal &amp; Compliance</strong>
                    <Link to="/compliance">Compliance</Link>
                    <Link to="/important-disclosures-risks">Important Disclosures &amp; Risks</Link>
                    <Link to="/principal-adverse-impacts">Principal Adverse Impacts</Link>
                    <Link to="/best-execution">Best Execution</Link>
                    <Link to="/conflicts-of-interest">Conflicts of Interest</Link>
                    <Link to="/terms-of-use">Terms of Use</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/fees">Fees</Link>
                    <Link to="/complaints">Complaints</Link>
                    <Link to="/scam-prevention">Scam Prevention</Link>
                </div>
            </div>
            <div className="container" style={{ marginTop: 12, marginBottom: 12, padding: "20px 0px" }}>
                <p style={{ fontSize: 12, color: "var(--muted)" }}>
                    The information on this website is provided for general informational purposes only and does not constitute
                    financial, investment, legal, or tax advice. Everest does not provide advice or recommendations in relation to
                    virtual financial assets.
                    <br />
                    This website is not directed at, and Everest does not provide services to, persons located in jurisdictions
                    where such services would be contrary to applicable laws or regulations. Users are responsible for ensuring
                    compliance with their local laws.
                    <br />
                    Everest provides services to eligible business customers only. Services may be subject to onboarding, regulatory
                    permissions, and jurisdictional availability.
                    <br />
                    This website, its contents, and the services displayed are not intended for, or directed at, UK consumers. The
                    information provided on this website is not intended to constitute financial advice for UK residents.
                    <br />
                    Crypto-assets are highly volatile and may result in partial or total loss of funds. These services are not covered by deposit guarantee schemes or investor compensation schemes. Past performance is not indicative of future results.
                    <br />
                    Fees vary depending on services and are disclosed prior to onboarding. Clients may access full details on fees, complaints handling, and legal documentation via the Legal & Compliance section.
                </p>
            </div>
            <div style={{ backgroundColor: "#ffffff", textAlign: "center", padding: "12px 16px", fontSize: 12 }}>
                <a
                    href="https://www.mfsa.mt/financial-services-register/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "underline" }}
                >
                    Everest Network Ltd. is licensed by the Malta Financial Services Authority as a Virtual Financial Asset Service
                    Provider under the Virtual Financial Assets Act and operates under applicable transitional arrangements pending authorisation under Regulation (EU) 2023/1114 on Markets in Crypto-Assets (MiCA).

                </a>
            </div>
        </footer>
    );
}

export default function Layout({ children }) {
    return (
        <div className="page-shell">
            <Header />
            <main id="main">
                {children}
            </main>
            <Footer />
        </div>
    );
}
